/**
 * Command sequence progress reports: the FrontEndMessages VTS emits while a
 * schema v8 channel-modifier program runs.
 *
 * A progress report carries the message that was COMMANDED, so a reader can
 * tell which call the run belongs to, with `ackOutcome = SequenceProgress` and a
 * `sequence` table. It is provenance about a command, never lift state: applied
 * as a delta it would show the command as done (a `SecureCarCall` going active,
 * a floor lock flipping). These two predicates are the one place that says what
 * counts as one, for the unpacked and the still-packed form.
 */
import { AckOutcome } from "../generated/front-end/ack-outcome";
import type { FrontEndMessage, FrontEndMessageT } from "../generated/front-end/front-end-message";

/** Whether an unpacked message is a sequence progress report. */
export function isSequenceProgress(fem: FrontEndMessageT): boolean {
  return fem.ackOutcome === AckOutcome.SequenceProgress || fem.sequence !== null;
}

/** The same test on a message still in its buffer, without unpacking it. */
export function isSequenceProgressTable(fem: FrontEndMessage): boolean {
  return fem.ackOutcome() === AckOutcome.SequenceProgress || fem.sequence() !== null;
}
